export default __webpack_public_path__ + "locales/lv/ChangeUserTypeDialog.json?hash=9a5f80c3aa64109f8beb016c353ef89e";